import BallotIcon from "@mui/icons-material/Ballot";

// Market Place React views

import RTL from "views/rtl";
import Profile from "views/authentication/profile";
import SignIn from "views/authentication/sign-in";
import SignUp from "views/authentication/sign-up";

import MainMenuView from "views/mainScreen/MainMenuView";
import FileScreen from "views/fileScreen/FileScreen";
import FileList from "views/fileScreen/FileList";
import Notifications from "views/mainScreen/NotificationView";

import PageView from "views/page/PageView";
import CooperateList from "views/authentication/cooperate/CooperateList";
import ChatroomView from "views/forum/ChatroomView";

const routes = [
  {
    type: "collapse",
    sidebar: false,
    name: "MainMenuView",
    key: "MainMenuView",
    icon: <BallotIcon />,
    route: "/main/:headline",
    component: <MainMenuView />,
  },
  {
    type: "collapse",
    sidebar: false,
    name: "pageview",
    key: "pageview",
    icon: <BallotIcon />,
    route: "/pageview",
    component: <PageView />,
  },

  {
    type: "collapse",
    sidebar: false,
    name: "FileScreen",
    key: "FileScreen",
    icon: <BallotIcon />,
    route: "/files/",
    component: <FileScreen />,
  },
  {
    type: "collapse",
    sidebar: false,
    name: "MyFiles",
    key: "MyFiles",
    icon: <BallotIcon />,
    route: "/myfiles",
    component: <FileList />,
  },
  {
    type: "collapse",
    sidebar: true,
    name: "RTL",
    key: "rtl",
    icon: <BallotIcon />,
    route: "/rtl",
    component: <RTL />,
  },
  {
    type: "collapse",
    sidebar: true,
    name: "Notifications",
    key: "notifications",
    icon: <BallotIcon />,
    route: "/notifications",
    component: <Notifications />,
  },
  {
    type: "collapse",
    sidebar: true,
    name: "Profile",
    key: "profile",
    icon: <BallotIcon />,
    route: "/profile",
    component: <Profile />,
  },
  {
    type: "collapse",
    sidebar: true,
    name: "cooperates",
    key: "cooperates",
    icon: <BallotIcon />,
    route: "/cooperates",
    component: <CooperateList />,
  },
  {
    type: "collapse",
    sidebar: true,
    name: "chatroom",
    key: "chatroom",
    icon: <BallotIcon />,
    route: "/chatroom/:selected?",
    component: <ChatroomView />,
  },
  {
    type: "collapse",
    sidebar: true,
    name: "chatroom",
    key: "chatroom",
    icon: <BallotIcon />,
    route: "/chatroom",
    component: <ChatroomView />,
  },

  {
    type: "collapse",
    sidebar: true,
    name: "Sign In",
    key: "sign-in",
    icon: <BallotIcon />,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "collapse",
    sidebar: true,
    name: "Sign Up",
    key: "sign-up",
    icon: <BallotIcon />,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
];
export default routes;
